//C:\Users\Ahmad\Desktop\academies\frontend\src\axios.js
// src/axios.js
import axios from "axios";

const instance = axios.create({
    baseURL:
        process.env.NODE_ENV === "production"
            ? "https://academy.zainab-alnajm.com"
            : "http://localhost:8000",
    timeout: 600000,
    withCredentials: true,
});


export default instance;
